import type { Prototype } from "../prototype-types";

export const tomFischerPrototypes: Prototype[] = [
  {
    id: "tf-reorder-hub-orders-page-entrypoint",
    name: "[Reorder Hub] Orders page entrypoint",
    path: "/tf/reorder-hub-orders-page-entrypoint",
    description:
      "An entrypoint to the Reorder Hub from the Orders page, to help increase discoverability",
    owner: "Tom Fischer",
    createdAt: "2026-05-08",
    lastUpdated: "2026-05-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/7a19cd6bbcdf5c2ec7258350ca2bb2957bfc963610a23d1b42d007e1830555e9.png",
    creationTool: "claude-code",
    project: "Reorder Hub",
  },
  {
    id: "tf-reorder-hub-organize-by-brand",
    name: "[Reorder Hub] Organize by brand",
    path: "/tf/reorder-hub-organize-by-brand",
    description: "",
    owner: "Tom Fischer",
    createdAt: "2026-05-08",
    lastUpdated: "2026-05-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/9d4056834d7f60a1f0c9fa1cad8d1a11e886fd3721b93dc980ab57299f4e7833.png",
    creationTool: "claude-code",
    project: "Reorder Hub",
  },
  {
    id: "tf-global-sidecart",
    name: "Global Sidecart",
    path: "/tf/global-sidecart",
    description: "Reorder Hub with a global, multi-brand sidecart that appears across surfaces (not just brand/PDP), with push, float, and right mini-rail variants, plus add-to-cart confirmation arms (panel open with auto-close, slim toast, large toast)",
    owner: "Tom Fischer",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/67e2f42ef4dc08a5d3b82f2984791110d1eeeb5911d7fc73dd581c2f1214400f.png",
    creationTool: "claude-code",
  }
];
